import React, { Fragment, useState } from "react";
import {
  EuiBadge,
  EuiButton,
  EuiButtonIcon,
  EuiConfirmModal,
  EuiFieldText,
  EuiForm,
  EuiFormRow,
  EuiHealth,
  EuiIcon,
  EuiIconTip,
  EuiInMemoryTable,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiSelect,
  EuiSpacer,
  EuiTextArea,
} from "@elastic/eui";
import { useEffect } from "react";
import OrganizationService from "../../services/organization-service";
import TeamsUserEdit from "./TeamUserEdit";

const TeamsUsersTable = (props) => {
  const [teamsUsers, setTeamsUsers] = useState([]);
  const organizationId = props.data.company;

  const isDatabaseCompany =
  props?.data?.permissions === "database" ||
  props?.data?.data?.permissions === "database";

  console.log("TeamsUsersTable props:", props);
  console.log("TeamsUsersTable isDatabaseCompany:", isDatabaseCompany);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalLicenses, setModalLicenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isClosed, setIsClosed] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const [userToUnapply, setUserToUnapply] = useState(null);
  const [isUnapplying, setIsUnapplying] = useState(false);

  const [userToEdit, setUserToEdit] = useState(null);

  const [editForm, setEditForm] = useState({
    name: "",
    email: "",
    extension: "",
    did: "",
  });

  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  const [isCreatingUser, setIsCreatingUser] = useState(false);
  const [createdUserInfo, setCreatedUserInfo] = useState(null);

  const [userToDelete, setUserToDelete] = useState(null);
  const [isDeletingUser, setIsDeletingUser] = useState(false);

  const [createForm, setCreateForm] = useState({
    name: "",
    email: "",
    extension: "",
    did: "",
  });

  const openCreateUserModal = () => {
    setCreatedUserInfo(null);

    setCreateForm({
      name: "",
      email: "",
      extension: "",
      did: "",
    });

    setIsCreateModalVisible(true);
  };

  const showModal = (licenses) => {
    setIsModalVisible(true);
    setModalLicenses(licenses);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const openEditModal = (user) => {
    setUserToEdit(user);

    setEditForm({
      name: user.DisplayName || "",
      email: user.UserPrincipalName || "",
      extension: user.extension || "",
      did: user.didId || "",
    });
  };

  const toggleIsClosed = () => setIsClosed((prevState) => !prevState);

  const renderModal = () => {
    return (
      <EuiModal onClose={closeModal} style={{ width: "800px" }}>
        <EuiModalHeader>
          <h1>
            <b>Assigned Licenses</b>
          </h1>
        </EuiModalHeader>
        <EuiModalBody>
          {modalLicenses.map((license, index) => (
            <div key={index}>
              <EuiBadge color={getColorForIndex(index)}>{license}</EuiBadge>
              <EuiSpacer size="xs" />
            </div>
          ))}
        </EuiModalBody>
        <EuiModalFooter>
          <EuiButton onClick={closeModal}>Close</EuiButton>
        </EuiModalFooter>
      </EuiModal>
    );
  };

  const createDatabaseUser = async () => {
    try {
      setIsCreatingUser(true);
      setErrorMessage("");

      const token = sessionStorage.getItem("krakenT");

      const response = await OrganizationService.createDatabaseUser({
        token,
        data: {
          companyId: organizationId,
          fullName: createForm.name,
          email: createForm.email,
          extension: createForm.extension,
          did: createForm.did,
        },
      });

      const createdUser = response.data?.data?.data || response.data?.data;

      setCreatedUserInfo({
        email: createdUser?.email || createForm.email,
        password: createdUser?.softphonePassword || "",
        extension: createdUser?.extension || createForm.extension,
        did: createdUser?.did || createForm.did,
      });

      toggleIsClosed();
    } catch (error) {
      console.log(error);
      setErrorMessage(
        error?.response?.data?.message || "Error creating user"
      );
    } finally {
      setIsCreatingUser(false);
    }
  };

  const deleteDatabaseUser = async () => {
    if (!userToDelete) return;

    try {
      setIsDeletingUser(true);
      setErrorMessage("");

      const token = sessionStorage.getItem("krakenT");

      await OrganizationService.deleteDatabaseUser({
        token,
        data: {
          userId: userToDelete.id,
          companyId: organizationId,
        },
      });

      setUserToDelete(null);
      toggleIsClosed();
    } catch (error) {
      console.log(error);
      setErrorMessage(
        error?.response?.data?.message || "Error deleting user"
      );
    } finally {
      setIsDeletingUser(false);
    }
  };

  const colors = ["primary", "warning", "accent", "success", "danger"];

  function getColorForIndex(index) {
    return colors[index % colors.length];
  }

  const search = {
    box: {
      incremental: true,
      schema: true,
    },
  };

  useEffect(() => {
    setLoading(true);
    setTeamsUsers([]);
    setErrorMessage("");

    const token = sessionStorage.getItem("krakenT");

    OrganizationService.getTeamsUsersByPowershell({ token, organizationId })
      .then(({ data: { data: teamsUsers } }) => {
        setTeamsUsers(Array.isArray(teamsUsers) ? teamsUsers : []);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setErrorMessage("Access denied");
        setTeamsUsers([]);
        setLoading(false);
      });
  }, [organizationId, isClosed]);

  const unapplyUserConfig = async () => {
    if (!userToUnapply) return;

    try {
      setIsUnapplying(true);
      setErrorMessage("");

      const token = sessionStorage.getItem("krakenT");

      await OrganizationService.unapplyUserConfig({
        token,
        data: {
          organizationId,
          email: userToUnapply.UserPrincipalName,
          lineUri: userToUnapply.LineUri,
          userIdentity: userToUnapply.UserIdentity,
        },
      });

      setUserToUnapply(null);
      toggleIsClosed();
    } catch (error) {
      console.log(error);
      setErrorMessage("Error removing Teams user configuration");
    } finally {
      setIsUnapplying(false);
    }
  };

  const saveUser = async () => {
    if (!userToEdit) return;

    try {
      setErrorMessage("");

      const token = sessionStorage.getItem("krakenT");

      await OrganizationService.updateDatabaseUser({
        token,
        data: {
          userId: userToEdit.id,
          companyId: organizationId,
          fullName: editForm.name,
          email: editForm.email,
          extension: editForm.extension,
          did: editForm.did,
        },
      });

      setUserToEdit(null);
      toggleIsClosed();
    } catch (error) {
      console.log(error);
      setErrorMessage("Error updating user");
    }
  };

  const teamsActions = [
    {
      name: "Edit",
      render: (item) => (
        <TeamsUserEdit
          props={item}
          organizationId={props.data.company}
          closeModalProp={toggleIsClosed}
        />
      ),
    },
    {
      name: "Remove",
      render: (item) => {
        const canRemove = item.LineUri || item.OnlineVoiceRoutingPolicy;

        return (
          <EuiButtonIcon
            iconType="cross"
            color="danger"
            aria-label="Remove Teams config"
            title="Remove Teams config"
            isDisabled={!canRemove}
            onClick={() => setUserToUnapply(item)}
          />
        );
      },
    },
  ];

  const databaseActions = [
    {
      name: "Edit",
      render: (item) => (
        <EuiButtonIcon
          iconType="documentEdit"
          color="text"
          aria-label="Edit user"
          title="Edit user"
          onClick={() => openEditModal(item)}
        />
      ),
    },
    {
      name: "Delete",
      render: (item) => (
        <EuiButtonIcon
          iconType="trash"
          color="danger"
          aria-label="Delete user"
          title="Delete user"
          onClick={() => setUserToDelete(item)}
        />
      ),
    },
  ];

  const databaseColumns = [
  {
    name: "",
    actions: databaseActions,
    width: 80,
  },
  {
    field: "DisplayName",
    name: "Name",
    sortable: true,
    truncateText: true,
  },
  {
    field: "UserPrincipalName",
    name: "Email",
    sortable: true,
    truncateText: true,
  },
  {
    field: "extension",
    name: "Extension",
    sortable: true,
    truncateText: true,
  },
  {
    field: "didId",
    name: "DID",
    sortable: true,
    truncateText: true,
  },
  {
    field: "WhenCreated",
    name: "Created",
    sortable: true,
    truncateText: true,
  },
  {
    field: "WhenChanged",
    name: "Updated",
    sortable: true,
    truncateText: true,
  },
  ];

  const teamsColumns = [
    {
      name: "",
      actions: teamsActions,
      width: 80,
    },
    {
      field: "UserPrincipalName",
      name: (
        <>
          <EuiIcon
            type={
              "https://commons.wikimedia.org/wiki/Special:FilePath/Microsoft_Office_Teams_(2018–present).svg"
            }
            size="s"
            title="Custom SVG icon"
          />
          &nbsp; UserPrincipalName
        </>
      ),
      sortable: true,
      truncateText: true,
    },
    {
      field: "DisplayName",
      name: (
        <>
          <EuiIcon
            type={
              "https://commons.wikimedia.org/wiki/Special:FilePath/Microsoft_Office_Teams_(2018–present).svg"
            }
            size="s"
            title="Custom SVG icon"
          />
          &nbsp; DisplayName
        </>
      ),
      sortable: true,
      truncateText: true,
    },
    {
      field: "AccountEnabled",
      name: "AccountEnabled",
      render: (status) => <EuiHealth color={status ? "success" : "danger"} />,
      sortable: true,
      truncateText: true,
    },
    {
      field: "EnterpriseVoiceEnabled",
      name: "EnterpriseVoiceEnabled",
      render: (status) => <EuiHealth color={status ? "success" : "danger"} />,
      sortable: true,
      truncateText: true,
    },
    {
      field: "FeatureTypes",
      width: "20%",
      name: "FeatureTypes",
      render: (licenses) => {
        if (Array.isArray(licenses) && licenses.length > 0) {
          return licenses.map((license, index) => (
            <EuiBadge color={"#6264a7"} key={index}>
              {license}
            </EuiBadge>
          ));
        }

        return null;
      },
      sortable: true,
      truncateText: true,
    },
    {
      field: "LineUri",
      width: "20%",
      name: "LineUri",
      sortable: true,
      truncateText: true,
    },
    {
      field: "OnlineVoiceRoutingPolicy",
      name: "OnlineVoiceRoutingPolicy",
      sortable: true,
      truncateText: true,
    },
    {
      field: "UsageLocation",
      name: "UsageLocation",
      sortable: true,
      truncateText: true,
    },
    {
      field: "WhenCreated",
      name: "WhenCreated",
      sortable: true,
      truncateText: true,
    },
    {
      field: "WhenChanged",
      name: "WhenChanged",
      sortable: true,
      truncateText: true,
    },
    {
      field: "FlexActive",
      render: (status) => <EuiHealth color={status ? "success" : "danger"} />,
      name: (
        <>
          <EuiIcon
            type={
              "https://aadcdn.msftauthimages.net/c1c6b6c8-efe-6zmeou8nd-7fuw534xg-jiqgje2bymedfubegbs/appbranding/pzhsywlsufptpj1ssfphq9vjieb0yvg9mdrqkjf32ym/1033/bannerlogo?ts=638442076533768204"
            }
            size="s"
            title="Custom SVG icon"
          />
          &nbsp; Active{" "}
          <EuiIconTip
            content="Flex active checks if the user exists in the Flex node corresponding to the tenant."
            position="right"
          />
        </>
      ),
      sortable: true,
      truncateText: true,
    },
    {
      field: "FlexSync",
      render: (status) => <EuiHealth color={status ? "success" : "danger"} />,
      name: (
        <>
          <EuiIcon
            type={
              "https://aadcdn.msftauthimages.net/c1c6b6c8-efe-6zmeou8nd-7fuw534xg-jiqgje2bymedfubegbs/appbranding/pzhsywlsufptpj1ssfphq9vjieb0yvg9mdrqkjf32ym/1033/bannerlogo?ts=638442076533768204"
            }
            size="s"
            title="Custom SVG icon"
          />
          &nbsp;Sync{" "}
          <EuiIconTip
            content="Flex Sync checks if Flex is taking into account the user's presence."
            position="right"
          />
        </>
      ),
      sortable: true,
      truncateText: true,
    },
  ];

  const columns = isDatabaseCompany ? databaseColumns : teamsColumns;

  const createdUserText = createdUserInfo
  ? [
      `Usuario: ${createdUserInfo.email}`,
      `Pass: ${createdUserInfo.password}`,
      `Extensión: ${createdUserInfo.extension}`,
      `DDI Saliente: ${createdUserInfo.did}`,
    ].join("\n")
  : "";

  return (
    <Fragment>
      <EuiSpacer size="l" />

      {isDatabaseCompany && (
        <>
          <EuiButton fill iconType="plusInCircle" onClick={openCreateUserModal}>
            Crear usuario
          </EuiButton>

          <EuiSpacer size="m" />
        </>
      )}

      <EuiInMemoryTable
        message={
          loading
            ? "Loading ..."
            : errorMessage
            ? errorMessage
            : "No items found"
        }
        loading={loading}
        tableCaption={
          isDatabaseCompany ? "Database Users List" : "Teams Users List"
        }
        items={teamsUsers}
        columns={columns}
        search={search}
        pagination={true}
        sorting={true}
      />

      {isModalVisible && renderModal()}

      {userToEdit && (
        <EuiModal onClose={() => setUserToEdit(null)} style={{ width: "500px" }}>
          <EuiModalHeader>
            <h1>
              <b>Edit user</b>
            </h1>
          </EuiModalHeader>

          <EuiModalBody>
            <EuiForm>
              <EuiFormRow label="Name">
                <EuiFieldText
                  value={editForm.name}
                  onChange={(e) =>
                    setEditForm({
                      ...editForm,
                      name: e.target.value,
                    })
                  }
                />
              </EuiFormRow>

              <EuiFormRow label="Email">
                <EuiFieldText
                  value={editForm.email}
                  onChange={(e) =>
                    setEditForm({
                      ...editForm,
                      email: e.target.value,
                    })
                  }
                />
              </EuiFormRow>

              <EuiFormRow label="Extension">
                <EuiFieldText
                  value={editForm.extension}
                  onChange={(e) =>
                    setEditForm({
                      ...editForm,
                      extension: e.target.value,
                    })
                  }
                />
              </EuiFormRow>

              <EuiFormRow label="DID">
                <EuiFieldText
                  value={editForm.did}
                  onChange={(e) =>
                    setEditForm({
                      ...editForm,
                      did: e.target.value,
                    })
                  }
                />
              </EuiFormRow>
            </EuiForm>
          </EuiModalBody>

          <EuiModalFooter>
            <EuiButton onClick={() => setUserToEdit(null)}>
              Cancel
            </EuiButton>

            <EuiButton fill onClick={saveUser}>
              Save
            </EuiButton>
          </EuiModalFooter>
        </EuiModal>
      )}

      {isCreateModalVisible && (
        <EuiModal
          onClose={() => setIsCreateModalVisible(false)}
          style={{ width: "550px" }}
        >
          <EuiModalHeader>
            <h1>
              <b>Crear usuario</b>
            </h1>
          </EuiModalHeader>

          <EuiModalBody>
            <EuiForm>
              <EuiFormRow label="Name">
                <EuiFieldText
                  value={createForm.name}
                  onChange={(e) =>
                    setCreateForm({
                      ...createForm,
                      name: e.target.value,
                    })
                  }
                />
              </EuiFormRow>

              <EuiFormRow label="Email">
                <EuiFieldText
                  value={createForm.email}
                  onChange={(e) =>
                    setCreateForm({
                      ...createForm,
                      email: e.target.value,
                    })
                  }
                />
              </EuiFormRow>

              <EuiFormRow label="Extension">
                <EuiFieldText
                  value={createForm.extension}
                  onChange={(e) =>
                    setCreateForm({
                      ...createForm,
                      extension: e.target.value,
                    })
                  }
                />
              </EuiFormRow>

              <EuiFormRow label="DID">
                <EuiFieldText
                  value={createForm.did}
                  onChange={(e) =>
                    setCreateForm({
                      ...createForm,
                      did: e.target.value,
                    })
                  }
                />
              </EuiFormRow>

              {createdUserInfo && (
                  <>
                    <EuiSpacer size="m" />

                    <EuiFormRow label="Usuario creado">
                      <EuiTextArea
                        readOnly
                        value={createdUserText}
                      />
                    </EuiFormRow>
                  </>
                )}
            </EuiForm>
          </EuiModalBody>

          <EuiModalFooter>
            <EuiButton onClick={() => setIsCreateModalVisible(false)}>
              Cerrar
            </EuiButton>

            <EuiButton
              fill
              onClick={createDatabaseUser}
              isLoading={isCreatingUser}
              isDisabled={
                !createForm.name.trim() ||
                !createForm.email.trim() ||
                !createForm.extension.trim() ||
                !createForm.did.trim()
              }
            >
              Crear usuario
            </EuiButton>
          </EuiModalFooter>
        </EuiModal>
      )}

      {userToDelete && (
        <EuiConfirmModal
          title="Eliminar usuario"
          onCancel={() => setUserToDelete(null)}
          onConfirm={deleteDatabaseUser}
          cancelButtonText="Cancelar"
          confirmButtonText="Eliminar"
          buttonColor="danger"
          isLoading={isDeletingUser}
        >
          <p>
            Vas a eliminar este usuario de la base de datos y del softphone:
          </p>

          <p>
            <b>{userToDelete.DisplayName}</b>
            <br />
            {userToDelete.UserPrincipalName}
          </p>

          <p>
            Extensión: <b>{userToDelete.extension}</b>
          </p>

          <p>
            DID: <b>{userToDelete.didId}</b>
          </p>
        </EuiConfirmModal>
      )}

      {!isDatabaseCompany && userToUnapply && (
        <EuiConfirmModal
          title="Remove Teams configuration"
          onCancel={() => setUserToUnapply(null)}
          onConfirm={unapplyUserConfig}
          cancelButtonText="Cancel"
          confirmButtonText="Remove"
          buttonColor="danger"
          isLoading={isUnapplying}
        >
          <p>
            This will remove the voice routing policy and the assigned phone
            number for:
          </p>

          <p>
            <b>{userToUnapply.UserPrincipalName}</b>
          </p>

          {userToUnapply.LineUri && (
            <p>
              Current number: <b>{userToUnapply.LineUri}</b>
            </p>
          )}
        </EuiConfirmModal>
      )}
    </Fragment>
  );
};

export default TeamsUsersTable;